import { Injectable } from '@angular/core';
import { ElementsConfig } from '../../../pages/user-details/config/user-data.config';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as StoreModel from '../../../model/ngrx';
import { AppState } from 'src/app/store/state/app.state';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

@Injectable({
    providedIn: 'root'
})
export class FundsModelFunctionalityService {

    public fundDetails: StoreModel.YourPension;
    productChoice: StoreModel.ProductChoice;
    protected transferType: any;

    constructor(private store: Store<AppState>) {
        this.store.select(STORE_VAL.your_pension).subscribe((val) => {
            if (val.length > 0) {
                this.fundDetails = val[0];
            }
        });
        this.store.select(STORE_VAL.product_choice).subscribe((val) => {
            if (val.length > 0) {
                this.productChoice = val[0];
            }
        });
    }

    // This function defaultFundModel- return fundModel JSON Object
    public defaultFundModel() {
        return {
            valuationExpiryDate: '',
            title: '',
            forename: '',
            surname: '',
            dateOfBirth: '',
            postcode: '',
            funds: [],
            policies: [],
            selectedInd: null
        };
    }

    // This method returns fund JSON Object
    public createFundObj(policyFundValue, policyFundType, policyValueType) {
        return {
            value: policyFundValue,
            type: policyFundType,
            valueType: policyValueType,
            valuationDate: '',
            revaluedAmount: '',
            crystalisedInd: 'N'
        };
    }
    // This method returns Policy JSON object
    public createPolicyObj(fundProvider, transferTypeVal, pCode, bScope?) {
        return {
            cedingProvider: fundProvider,
			transferType: transferTypeVal,
			productCode: pCode,
			policyNo: '',
			policyDate: '',
			bankruptcy: '',
			fullFund: '',
			ptfc: '',
			retirementDate: '',
			withProfitsInd: '',
			dealPartnerPolicyStrtDt: '',
			businessScope: bScope ? bScope : ''
        };
    }

    // This function will create Fund Model * @Param benefitBasis data object * return the fund Model Array
    public createFundModel(source, benefitBasisData) {
        let fundArray = [];
        this.transferType = (this.productChoice && this.productChoice.selectedProduct !== 'C' && this.productChoice.selectedProduct !== '') ? 'IVPP' : 'OMO';

        fundArray.push(this.defaultFundModel());
        if ((source !== 'B' && source !== 'R') && benefitBasisData && benefitBasisData.externalFundAmount > 0) {
            fundArray.push(this.defaultFundModel());
        }
        // capturing the fundModel values
        ((source === 'B' || source === 'R') && fundArray && fundArray.length === 1) ?
            this.externalCase(fundArray, benefitBasisData, source) :
            source ? this.dealPartnerCase(fundArray, benefitBasisData, source) : '';

        fundArray.forEach(val => {
            val.selectedInd = true;
        });

        return fundArray;
    }

    public externalCase(funArr, benefitBasisData, source) {
        funArr.forEach((element, index) => {
            switch (index) {
                case 0:
                    this.externalFundData(element, this.transferType, benefitBasisData);
                    this.externalPolicy(element, source, this.transferType);
                    break;

            }
        });

    }

    public dealPartnerCase(funArr, benefitBasisData, source) {
        funArr.forEach((element, index) => {
            switch (index) {
                case 0:
                    this.dealPartnerFundData(element, benefitBasisData);
                    this.policyArray(element, source, this.transferType);
                    break;
                case 1:
                    this.externalFundWithDP(element, benefitBasisData);
                    this.externalPolicy(element, 'B', this.transferType);
                    break;
            }
        });

    }

    /* This method is called only in case of External Source selection */
    public externalFundData(element, transferType, benefitBasisData) {
        if (benefitBasisData.pensionFund) {
            const fundValue = benefitBasisData.pensionFund;
            element.funds.push(this.createFundObj((this.fundDetails.fundProvider === 'R' ? fundValue?.toFixed(2) : fundValue), 'CDF', 'PND'));
        }

        switch (transferType) {
            case 'OMO':
                if (benefitBasisData.extTaxFreeCashAmountPercent && benefitBasisData.extTaxFreeCashAmountPercent !== null &&
                    benefitBasisData.extTaxFreeCashAmountPercent !== '' && benefitBasisData.extTaxFreeCashAmountPercent !== 'N') {
                    const policyFundValue = (benefitBasisData.extTaxFreeCashAmountPercent === 'P') ?
                        benefitBasisData.extTaxFreeCashPercentage : benefitBasisData.extTaxFreeCashAmount;
                    const policyValueType = (benefitBasisData.extTaxFreeCashAmountPercent === 'P') ? 'PCT' : 'PND';

                    element.funds.push(this.createFundObj(policyFundValue, 'Tfc', policyValueType));
                }
                break;

            case 'IVPP':
                if (benefitBasisData.taxFreeCashAmountPercent && benefitBasisData.taxFreeCashAmountPercent !== null &&
                    benefitBasisData.taxFreeCashAmountPercent !== '' && benefitBasisData.taxFreeCashAmountPercent !== 'N') {
                    const policyFundValue = (benefitBasisData.taxFreeCashAmountPercent === 'P') ?
                        benefitBasisData.taxFreeCashPercentage : benefitBasisData.taxFreeCashAmount;
                    const policyValueType = (benefitBasisData.taxFreeCashAmountPercent === 'P') ? 'PCT' : 'PND';

                    element.funds.push(this.createFundObj(policyFundValue, 'Tfc', policyValueType));
                }
                break;
        }
    }

    /* This method is called in case of External Source selection along with Deal Partners */
    public externalFundWithDP(element, benefitBasisData) {
        if (benefitBasisData.externalFundAmount) {
            element.funds.push(this.createFundObj(benefitBasisData.externalFundAmount, 'CDF', 'PND'));
        }

        if (benefitBasisData.extTaxFreeCashAmountPercent && benefitBasisData.extTaxFreeCashAmountPercent !== null &&
            benefitBasisData.extTaxFreeCashAmountPercent !== '' && benefitBasisData.extTaxFreeCashAmountPercent !== 'N') {

            const policyFundValue = (benefitBasisData.extTaxFreeCashAmountPercent === 'P') ?
                                    benefitBasisData.extTaxFreeCashPercentage : benefitBasisData.extTaxFreeCashAmount;
            const policyValueType = (benefitBasisData.extTaxFreeCashAmountPercent === 'P') ? 'PCT' : 'PND';

            element.funds.push(this.createFundObj(policyFundValue, 'Tfc', policyValueType));
        }

    }

    public dealPartnerFundData(element, benefitBasisData) {
        if (this.fundDetails) {
            const fundValue = (this.fundDetails.fundProvider === 'L' || this.fundDetails.fundProvider === 'M') ? benefitBasisData.pensionFund : this.fundDetails.cedingFund;
            if(fundValue !== null)
            {
                element.funds.push(this.createFundObj(fundValue.toFixed(2), 'CDF', 'PND'));
            }
            
        }

        if (benefitBasisData.taxFreeCashAmountPercent !== null &&
        benefitBasisData.taxFreeCashAmountPercent !== '' && benefitBasisData.taxFreeCashAmountPercent !== 'N') {

            const policyFundValue = (benefitBasisData.taxFreeCashAmountPercent === 'P') ?
            benefitBasisData.taxFreeCashPercentage : benefitBasisData.taxFreeCashAmount;
            const policyValueType = (benefitBasisData.taxFreeCashAmountPercent === 'P') ? 'PCT' : 'PND';

            element.funds.push(this.createFundObj(policyFundValue, 'Tfc', policyValueType));
        }
    }

    public externalPolicy(element, source, transferType) {
        element['policies'].push(this.createPolicyObj((source === 'R' ? 'B' : source), transferType, ''));
    }
    public policyArray(element, source, transferType) {
        if (this.fundDetails) {
            const sourceCode = source === 'I' ? 'Int.' : (source === 'B' ? 'Ext' : source);
            const fundProviderData = ElementsConfig.sourcesListCvt.filter(item => item.fundProvider === sourceCode);
            const productCode = fundProviderData.length>0 ? this.fundDetails[fundProviderData[0].controlName].productCode: [] ;
            if (productCode.length > 0 && source !== 'I') {
                productCode.forEach(pCode => {
                    pCode = (source === 'H' && pCode === '') ? '00' :
                    ((source === 'F' || source === 'O' && pCode === '') ? '0' : pCode);
                    element['policies'].push(this.createPolicyObj(source, transferType, pCode));
                });
            } else {
                element['policies'].push(this.createPolicyObj(source, transferType, '', 'OOS'));
            }
        }
    }
}
